import { configureStore } from '@reduxjs/toolkit'
import viewerReducer from "../features/viewerSlice";

export default configureStore({
  reducer: {
    viewer: viewerReducer,

  },
})